import refTypes from "./refTypes";
const shouldHaveContent = (errors, content, line, column) => {
    if (!content)
        errors.push({
            message: `Missing content. ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const maxLength = (errors, content, line, column) => {
    if (content.length > 255)
        errors.push({
            message: `Content too long (over 255 characters). ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const validType = (errors, content, line, column) => {
    if (!refTypes.includes(content === null || content === void 0 ? void 0 : content.trim()))
        errors.push({
            message: `TY tag type "${content}" unknown. ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const endShouldHaveNoContent = (errors, content, line, column) => {
    if (content.length)
        errors.push({
            message: `ER tag should have no content. ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const authorFormat = (errors, content, line, column) => {
    if (!content)
        return;
    const commas = [...content.trim().matchAll(/,/g)].length;
    const hasSpaceButNoCommas = content.includes(" ")
        && commas === 0;
    const hasTooManyCommas = commas > 2;
    if (hasSpaceButNoCommas || hasTooManyCommas)
        errors.push({
            message: `Authors should be formated as: Lastname, Firstname, Suffix. ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const publicationYearFormat = (errors, content, line, column) => {
    if (!(content === null || content === void 0 ? void 0 : content.trim().match(/^\d{1,4}$/)))
        errors.push({
            message: `Publication year (PY) should be a one to four digit number. ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const reprintFormat = (errors, content, line, column) => {
    if (!content)
        return;
    const reprintValues = [
        /IN FILE/,
        /NOT IN FILE/,
        /ON REQUEST (\d{2}\/\d{2}\/\d{2})/,
    ];
    const matches = reprintValues
        .map(rp => content.trim().match(rp))
        .filter(m => m);
    if (!matches || !matches.length)
        errors.push({
            message: `RP value should match one of: IN FILE, NOT IN FILE, ON REQUEST (mm/dd/yy). ${line}:${column}`,
            severity: "warning",
            column,
            line,
        });
};
const dateContentFormat = (errors, content, line, column) => {
    const message = `DA should be in format similar to YYYY/MM/DD/other. ${line}:${column}`;
    const parts = content.trim().split('/');
    const year = parts.shift();
    const yearGoodFormat = year && year.match(/^\d{1,4}$/);
    if (!yearGoodFormat)
        return errors.push({ message, severity: "warning", column, line });
    const month = parts.shift();
    if (month == null)
        return;
    const monthGoodFormat = !month.length
        || month.match(/^\d{2}$/);
    if (!monthGoodFormat)
        return errors.push({ message, severity: "warning", column, line });
    const day = parts.shift();
    if (day == null)
        return;
    const dayGoodFormat = !day.length
        || day.match(/^\d{2}$/);
    if (!dayGoodFormat)
        return errors.push({ message, severity: "warning", column, line });
};
const tagValidations = {
    'TY': [
        shouldHaveContent,
        validType,
    ],
    'ER': [
        endShouldHaveNoContent,
    ],
    'AU': [
        shouldHaveContent,
        maxLength,
        authorFormat,
    ],
    'PY': [
        shouldHaveContent,
        publicationYearFormat,
    ],
    'DA': [
        shouldHaveContent,
        dateContentFormat,
    ],
    'KW': [
        shouldHaveContent,
        maxLength,
    ],
    'RP': [
        shouldHaveContent,
        reprintFormat,
    ]
};
const quosaValidations = {
    'FAU': [
        maxLength
    ],
    'AU': [
        maxLength,
    ],
    'YR': [
        shouldHaveContent,
        publicationYearFormat,
    ],
    'DA': [
        shouldHaveContent,
    ],
    'KW': [
        shouldHaveContent,
        maxLength,
    ],
    'MH': [
        shouldHaveContent,
        maxLength,
    ]
};
export const runValidationsFor = ({ tag, errors }) => { var _a; return (_a = tagValidations[tag.tag]) === null || _a === void 0 ? void 0 : _a.forEach(tv => tv(errors, tag.content, tag.line, tag.column)); };
export const runQuosaValidationsFor = ({ tag, errors }) => { var _a; return (_a = quosaValidations[tag.tag]) === null || _a === void 0 ? void 0 : _a.forEach(tv => tv(errors, tag.content, tag.line, tag.column)); };
